<template>
  <page>
    <template slot="content">
      <help-content :title="'ランキング画面の毎週と毎月の対象期間は？'">
        <template slot="content">
          <div class="text">
            ランキングは暦週と暦月で集計されています。
          </div>
        </template>
      </help-content>
    </template>
  </page>
</template>

<script>
  import HelpContent from '@/components/HelpContent'
  import Page from '@/components/Page'

  export default {
    components: {
      HelpContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Help12.vue